"use client"

import React from "react"
import { useToc } from "@/hooks/use-toc"
import clsx from "clsx"

interface TableOfContentsProps {
  contentId: string
  containerId?: string
  targetSelectors?: string
  ignoreIds?: string[]
  tocContainer?: string
}

const TableOfContents: React.FC<TableOfContentsProps> = ({
  contentId,
  containerId,
  targetSelectors = "h1, h2, h3, h4, h5, h6",
  ignoreIds = [],
  tocContainer = ".toc-container",
}) => {
  const { headings, activeId } = useToc({
    contentId,
    containerId,
    targetSelectors,
    ignoreIds,
    tocContainer,
  })

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault()
    const element = document.getElementById(id)
    if (element) {
      const yOffset = -130
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: "smooth" })
      window.history.pushState(null, "", `#${id}`)
    }
  }

  return (
    <nav className="space-y-1 py-4">
      {headings.map((heading) => (
        <a
          key={heading.id}
          href={`#${heading.id}`}
          onClick={(e) => handleClick(e, heading.id)}
          className={clsx(
            "block py-1 px-3 text-sm transition-colors duration-200 ease-in-out rounded-md",
            activeId === heading.id
              ? "bg-primary/10 text-primary font-medium"
              : "text-muted-foreground hover:text-foreground",
            {
              "pl-6": heading.level === 3,
              "pl-9": heading.level === 4,
            },
          )}
        >
          {heading.text}
        </a>
      ))}
    </nav>
  )
}

export default TableOfContents
